<template>
  <div class="container">
    <div class="main">
      <!-- <div class="user-info">
        <van-image width="10vw" height="10vw" round :src="avatar"></van-image>
        <div class="title">{{ fullNickName }}</div>
      </div> -->
      <div class="grid-box" >
        <div class="grid-item" v-for="item,index in imageList" :key="index" @click="changeChecked(item, index)">
          <van-radio-group v-model="checked" >
            <img :class="checked == index +1 ? 'image-item checked' : 'image-item'" :src="item.imgUrl" >
            <van-radio class="radio" :name="index + 1" />
          </van-radio-group>
        </div>
      </div>
      <div class="btn-div">
        <div 
          class="btn button glass ech-shake-time" 
          @click="handleClick()"
        >
          {{ checked ? "确定" : "选择你喜欢的海报"}}
        </div>
      </div>
      <van-button
            color="#1EA6FC"
            plain
            class="bottom-btn"
            url="https://zsrbactivity.zsnews.cn/vue/talk/#/info/29"
            >前往话题广场发帖参与互动</van-button
          >
    </div>
  </div>
</template>
<script>
import {
  Button,
  Toast,
  RadioGroup, 
  Radio,
  Cell,
  Image as VanImage,
} from "vant";
import { ref, computed, reactive, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
export default {
  name: "Home",
  components: {
    [VanImage.name]: VanImage,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Cell.name]: Cell,
  },
  setup() {
    const loading = ref(false);
    const store = useStore();
    const router = useRouter();
    const checked = ref("");
    const imageUrl = ref("");
    const imageList = reactive([
      {imgUrl: require("../assets/img/poster111.png")},
      {imgUrl: require("../assets/img/poster222.png")},
      {imgUrl: require("../assets/img/poster333.png")},
      {imgUrl: require("../assets/img/poster444.png")},
    ])

    onMounted(() => {
      store.dispatch("getAppEnv");
    })

    const changeChecked = (item,index) =>{
      imageUrl.value = item.imgUrl
      checked.value = index +1
    }

    const handleClick = () => {
      console.log(router);
      if (!imageUrl.value) {
        Toast("请选择你喜欢的高考幸运海报");
        return;
      }
      router.push({ name: 'Detail', params: { url: imageUrl.value }});
    };

    return {
      loading,
      checked,
      changeChecked,
      handleClick,
      imageUrl,
      covers: computed(() => store.state.covers),
      avatar: computed(() => store.state.avatar),
      nickName: computed(() => store.state.nickName),
      fullNickName: computed(() => store.state.fullNickName),
      imageList,
    };
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  background: url('../assets/img/detail_background.png') no-repeat;
  background-color: #bbf3ff;
  background-size: 100%;
  min-height: 100vh;
  overflow-y: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0px;
}
.user-info{
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  margin-left: 6vw;
  .title{
    font-size: 18px;
    margin-left: 10px;
  }
}
.image-item {
  width: 100%;
  height: 216px;
}
.radio {
  position: absolute;
  top: 10px;
  right: 20px;
}
.btn-div {
  margin-top: 4vw;
  margin-bottom: 7vw;
}
.btn {
  background: #1EA6FC;
  box-shadow: 0.5px 0.8px 5px white;
}
.grid-box {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  .checked {
    border: #187ef9 2px solid;
  }
}

@media screen and(min-width: 414px)and(max-width: 700px){
  .grid-item {
    width: 46% !important;
  }
}

@media screen and(min-width: 310px)and(max-height: 730px){
  .grid-item {
    width: 41% !important; 
    padding: 2px;
  }
}

@media screen and(height: 812px)and(max-height: 812px){
  .grid-item {
    width: 44% !important; 
  }
}

.grid-item {
  width: 44%;
  position: relative;
  margin: 5px 0;
  img {
    width: 92%;
    height: 92%;
    box-shadow: 0.5px 0.8px 5px white;
  }
}
.bottom-btn{
  border-radius: 12px;
  width: 208px;
  height: 32px;
  line-height: 28px;
  padding: 4px 4px;
  // font-size: 3.8vw;
}
</style>
